var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRooms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400,88.5H112c-13.3,0-24,10.7-24,24v288c0,13.3,10.7,24,24,24h288c13.3,0,24-10.7,24-24v-288C424,99.2,413.3,88.5,400,88.5 z M408,400.5c0,4.4-3.6,8-8,8H112c-4.4,0-8-3.6-8-8v-288c0-4.4,3.6-8,8-8h288c4.4,0,8,3.6,8,8V400.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208,72.5h96c13.3,0,24-10.7,24-24v-16c0-13.3-10.7-24-24-24h-96c-13.3,0-24,10.7-24,24v16C184,61.8,194.7,72.5,208,72.5z  M200,32.5c0-4.4,3.6-8,8-8h96c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8h-96c-4.4,0-8-3.6-8-8V32.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304,440.5h-96c-13.3,0-24,10.7-24,24v16c0,13.3,10.7,24,24,24h96c13.3,0,24-10.7,24-24v-16 C328,451.2,317.3,440.5,304,440.5z M312,480.5c0,4.4-3.6,8-8,8h-96c-4.4,0-8-3.6-8-8v-16c0-4.4,3.6-8,8-8h96c4.4,0,8,3.6,8,8V480.5z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480,184.5h-16c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24h16c13.3,0,24-10.7,24-24v-96 C504,195.2,493.3,184.5,480,184.5z M488,304.5c0,4.4-3.6,8-8,8h-16c-4.4,0-8-3.6-8-8v-96c0-4.4,3.6-8,8-8h16c4.4,0,8,3.6,8,8V304.5z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48,184.5H32c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24h16c13.3,0,24-10.7,24-24v-96C72,195.2,61.3,184.5,48,184.5z  M56,304.5c0,4.4-3.6,8-8,8H32c-4.4,0-8-3.6-8-8v-96c0-4.4,3.6-8,8-8h16c4.4,0,8,3.6,8,8V304.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184,376.5h-56c-4.4,0-8,3.6-8,8s3.6,8,8,8h56c4.4,0,8-3.6,8-8S188.4,376.5,184,376.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216,376.5h-8c-4.4,0-8,3.6-8,8s3.6,8,8,8h8c4.4,0,8-3.6,8-8S220.4,376.5,216,376.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.244e1d14.svg";
export { ForwardRef as ReactComponent };